var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExclamationMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_19",
    "data-name": "Artboard \\u2013 19",
    clipPath: "url(#clip-Artboard_19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-alert",
    "data-name": "Icon ionic-ios-alert",
    d: "M15.875,3.375a12.5,12.5,0,1,0,12.5,12.5A12.5,12.5,0,0,0,15.875,3.375Zm1.034,6.587-.186,6.917a.86.86,0,0,1-.847.889h0a.86.86,0,0,1-.847-.889l-.186-6.917A1.035,1.035,0,0,1,15.875,8.9h0A1.035,1.035,0,0,1,16.909,9.962Zm-1.034,11.8a1.107,1.107,0,1,1,1.148-1.106A1.116,1.116,0,0,1,15.875,21.764Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#f5af0d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExclamationMark);
export default __webpack_public_path__ + "static/media/iconExclamationMark.f616ae42597e437f5b48ecf688ff65b4.svg";
export { ForwardRef as ReactComponent };